import "../../components/Tools/typdefs";
import UseAnswerHistory from "../../../services/SurveyInstances/SurveyAnswerHistory";

const HIST_MUTAIONS = {
  updateShow: "updateShow",
  replaceHistory: "replaceHistory",
  toggleHistoryfor: "toggleHistoryfor",
  showHistoryComponentFor: "showHistoryComponentFor",
  hideHistoryComponentFor: "hideHistoryComponentFor",
};

const state = {
  showHistForCheck: {},
  /** @type {ShowHistory[]} */
  showHistfor: [],
  /** @type {QuestionHistory[]} */
  answershist: [],
};

/** @type {import("vuex").GetterTree<typeof state,any>} */
const getters = {
  showbyName: (state) => (name) => {
    let hist = state.showHistfor.find((el) => el.name === name);
    if (hist) {
      return hist.show;
    } else {
      return false;
    }
  },
  historybyName: (state) => (name) => {
    let question = state.answershist.find((el) => el.name === name);
    if (question) {
      let answers = question.answers.map((a) => {
        return { ...a, type: question.type };
      });
      return answers;
    } else {
      return [];
    }
  },
  getHistory: (state) => () => {
    return state.answershist ? state.answershist : [];
  },
};

/** @type {import("vuex").ActionTree<typeof state>} */
const actions = {
  async fetchHistory({ commit, state }, payload) {
    const res = await UseAnswerHistory.getAnswersHistory(payload.id, {
      QuestionGuid: payload.names,
    });
    /**
     * @type {QuestionHistory[]}
     */
    let histData = [];
    let isHistenabled = res.data.HistoryCount && res.data.HistoryCount > 0;
    if (isHistenabled) {
      histData = res.data.HistoryAnswers;
      histData = Array.isArray(histData) ? histData : [];

      // we hope for no bugs but sometimes bugs
      for (const question of histData) {
        if (
          ["checkbox", "radiogroup"].includes(question.type) &&
          payload.choicesText[question.name]
        ) {
          let questiontext = payload.choicesText[question.name];
          for (const ans of question.answers) {
            ans.values = ans.values.map((val) => {
              const valueKey = questiontext.find((el) => el.value == val);
              if (valueKey) return valueKey.text;
              else return val;
            });
          }
        }
      }

      commit(HIST_MUTAIONS.showHistoryComponentFor, payload.id);
    } else {
      commit(HIST_MUTAIONS.hideHistoryComponentFor, payload.id);
    }
    const hist = histData;

    commit(HIST_MUTAIONS.replaceHistory, hist);
    hist.forEach((el) => {
      commit(HIST_MUTAIONS.updateShow, el);
    });
    return isHistenabled;
  },
};

/** @type {import("vuex").MutationTree<typeof state>} */
const mutations = {
  showHistoryComponentFor(state, id) {
    state.showHistForCheck[id] = true;
  },
  hideHistoryComponentFor(state, id) {
    state.showHistForCheck[id] = false;
  },
  toggleHistoryfor(state, { name, show }) {
    let hist = state.showHistfor.find((el) => el.name === name);

    if (hist) {
      hist.show = show;
    } else {
      state.showHistfor.push({ name, show });
    }
  },
  replaceHistory(state, payload) {
    state.answershist = payload;
  },
  updateShow(state, el) {
    state.showHistfor.push({ name: el.name, show: false });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/surveyjs/store/modules/AnswerHistoryStore.js